import styled from 'styled-components'
import pick from 'lodash/pick'

import useDispatch from 'hooks/useDispatch'

import { SearchQueryResult } from '../../../hooks/useQueries'
import {
  disallowedFiltersForType,
  updateFilters,
} from '../../../actions/searchActions'

import { Wrapper as FilterButtonWrapper } from './FilterButton'

import CapacityFilter from './CapacityFilter'
import DatesFilter from './DatesFilter'
import MultiSelectFilter from './MultiSelectFilter'
import MoreFilters from './MoreFilters'

const Wrapper = styled.div`
  padding: 8px 0;
  display: flex;
  flex-wrap: wrap;

  ${FilterButtonWrapper} {
    margin: 8px 8px;
  }
`

interface FilterBarProps {
  defaults: SearchQueryResult['data']['search']['defaults']
  minPrice: number
  maxPrice: number
  filters: GQL_SearchFilters
}

const FilterBar = ({
  filters,
  defaults,
  minPrice,
  maxPrice,
}: FilterBarProps) => {
  const dispatch = useDispatch()

  const onFiltersChange = (nextFilters: GQL_SearchFilters) =>
    dispatch(updateFilters(nextFilters))

  const getCapacityValues = () => pick(filters, ['adults', 'children', 'pets'])

  const { type: currentSearchTypeSlug } = filters
  const disallowedFilters = disallowedFiltersForType[currentSearchTypeSlug]

  return (
    <Wrapper>
      {!disallowedFilters?.includes('dates') && (
        <DatesFilter
          valueKey="dates"
          startDate={filters.startDate}
          endDate={filters.endDate}
          weekendMonths={filters.weekendMonths}
          onChange={onFiltersChange}
        />
      )}

      {!disallowedFilters?.includes('capacity') && (
        <CapacityFilter
          valueKey="capacity"
          values={getCapacityValues()}
          onChange={onFiltersChange}
        />
      )}

      {currentSearchTypeSlug === 'adventures' && (
        <>
          <MultiSelectFilter
            label="Regions"
            filterKey="regions"
            possibleOptions={defaults?.regions}
            selectedSlugs={filters?.regions}
          />

          <MultiSelectFilter
            label="Adventure types"
            filterKey="adventureTypes"
            possibleOptions={defaults?.adventureTypes}
            selectedSlugs={filters?.adventureTypes}
          />
        </>
      )}

      {currentSearchTypeSlug === 'accommodation' && (
        <MoreFilters
          defaults={defaults}
          filters={filters}
          minPrice={minPrice}
          maxPrice={maxPrice}
        />
      )}
    </Wrapper>
  )
}

export default FilterBar
